// ---------------------------
// Global Properties rootStore
// This controls all of the high-level states of the application for view reactivity.

import {observable, action, computed, autorun} from 'mobx';
import * as moment from 'moment'
import axios from 'axios';

class GlobalPropsStore {

  //General constructor
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.brApi = `KPN9KXDBSg2G8w4D1uscT1YKEVo8hqD66vfGfIJw`;
    this.year = parseInt(moment().format('YYYY'));
    this.baseURL = (window.location.origin == 'http://localhost:666')? 'http://allintovote.local' : window.location.origin;
    autorun(() => {
      //If step four, loading up, wait for response to unset loading
      if(this.wizardProps.wizardStep === 4){
        this.updateProp('isLoading', true);
        this.getAllWizardResults();
      }
    });
  }

  //All properties for the Wizard Props
  @observable wizardProps = {
    wizardStep: 1,
    wizardStateValue: null,
    wizardStateName: null,
    isLoading: true,
    isRegistered: null,
    voteMethod: null,
    isForward: true,
    registrationData: null,
    earlyVoting: null,
    isFinal: false,
    imagesLoaded: false,
    isInit: true
  };

  @observable globalProps = {
    lat: null,
    lng: null,
    address: null,
    eid: null,
  }

  //General update prop function
  @action updateProp = (prop, value) => {
    this.wizardProps[prop] = value;
  }

  //General update prop function
  @action updateGlobalProp = (prop, value) => {
    this.globalProps[prop] = value;
  }

  //array for iteration
  @observable electionResults = [];
  @observable pollingElections = [];

  @action getPollingElections = ()=>{
    const _this = this;
    this.pollingElections = [];
    axios.all([
      axios.get(`https://api.civicengine.com/elections?latitude=${_this.globalProps.lat}&longitude=${_this.globalProps.lng}`, {headers:{'x-api-key': 'KPN9KXDBSg2G8w4D1uscT1YKEVo8hqD66vfGfIJw'}}),
    ])
    .then(responseArr => {
      //this will be executed only when all requests are complete
      //Handle Elections API
      for (var election of responseArr[0].data.elections) {
        if(parseInt(moment(election.election_day).format('YYYY')) === 2024){
          _this.pollingElections.push(election);
        }
      }
    });
  }

  @action getPollingLocations = ()=>{
    const _this = this;
    axios.all([
      axios.get(`https://api.civicengine.com/polling_places?longitude=${_this.globalProps.lng}&latitude=${_this.globalProps.lat}&election_id=${_this.globalProps.eid}`, {headers:{'x-api-key': 'KPN9KXDBSg2G8w4D1uscT1YKEVo8hqD66vfGfIJw'}}),
    ])
    .then(responseArr => {
      //this will be executed only when all requests are complete
    });
  }

  //get all async wizard results
  // @todo - store in local storage prior
  @action getAllWizardResults = ()=>{
    const _this = this;
    const yy = new Date().getFullYear();

    this.electionResults = [];
    this.wizardProps.registrationData = null;
    this.wizardProps.earlyVoting = null;
    this.wizardProps.isInit = false;
    _this.updateProp('isLoading', true);

    axios.all([
      axios.get(`https://api.civicengine.com/elections?state=${_this.wizardProps.wizardStateValue}`, {headers:{'x-api-key': 'KPN9KXDBSg2G8w4D1uscT1YKEVo8hqD66vfGfIJw'}}),
      axios.get(`${this.baseURL}/wp-json/wp/v2/voting_data?slug=state-deadlines`)
    ])
    .then(responseArr => {
      //this will be executed only when all requests are complete
      _this.updateProp('isLoading', false);
      _this.updateProp('isFinal', true);

      //Handle Elections API
      for (var election of responseArr[0].data.elections) {
        if(parseInt(moment(election.election_day).format('YYYY')) === parseInt(yy)){
          _this.electionResults.push(election);
        }
      }

      //Handle WP API
      for(var votingData of responseArr[1].data[0].acf.data){
        if(votingData.name == _this.wizardProps.wizardStateName){
          //@todo if date is past the day checked, alert user...
          //set a global prop and ignore the following
          let dateConv = moment(votingData.value).format('MMM Do YYYY');
          _this.wizardProps.registrationData = dateConv;
          _this.wizardProps.earlyVoting = votingData.early_voting;
        }
      }
    });
  }

  //Obj for named extraction
  @observable wizardImages = {};

  //get all async image results
  // @todo - store in local storage prior
  @action getAllWizardImages = ()=>{
    const _this = this;
    axios.all([
      axios.get(`${this.baseURL}/wp-json/wp/v2/dynamic_data?slug=wizard-images`)
    ])
    .then(responseArr => {
      let images = responseArr[0].data[0].acf.images;
      for (var image of images) {
        this.wizardImages[image.image_slug] = {'url': image.image, 'alt': image.image_alt};
      }
      _this.updateProp('isLoading', false);
      _this.updateProp('imagesLoaded', true);
    });
  }

  //general pagination function
  @action paginate = () => {
    if(this.wizardProps.isForward){
      this.wizardProps.wizardStep ++;
    }else{
      this.wizardProps.wizardStep --;
    }
  }

  //gets all computed props on an update cycle
  //can be accessed directly via obj.prop
  @computed get getGlobalProps(){
    return this.wizardProps;
  }

}

export default GlobalPropsStore;
